(function () {

    var module = angular.module("app");

    module.directive("myCellar", function () {
        return {
            restrict: "E",
            templateUrl: "/app/features/myCellar/myCellar.tpl.html",
            scope: {},
            controller: "myCellarCtrl",
            controllerAs: "vm",
            bindToController: true
        };
    });

    module.controller("myCellarCtrl", [
        "myCellarService", "loading",
        function (myCellarService, loading) {
            var vm = this;

            vm.tracker = loading.createTracker();

            (function activate() {
                vm.tracker.track(
                    myCellarService.get().then(function(myCellar) {
                        vm.myCellar = myCellar;
                    })
                );
            }());
        }
    ]);
}());